<template>
  <div>
    <div 
      ref="selectorView" class="member-call-box"
      :style="height ? 'height:' + height + 'px;' : ''"
      >
      <div class="scroll" v-if="state.localUserList.length > 0 || (!state.isSearching && state.searchedUserList.length > 0)">
        <dl>
          <dt>{{ $i18nUtil.trans("message.member.searchResult","멤버 검색 결과") }}</dt>
          <dd v-if="state.localUserList.length > 0">
            <ul class="member-list">
              <template v-for="(userInfo, inx) in state.localUserList">
              <li
                :key="inx"
                v-if="userInfo.userName"
                class="memberlist-item"
                :class="{ 'memberlist-selected': (inx == state.selected || (state.localUserList.length + state.searchedUserList.length) == 1),
                          'member-all': userInfo.userId === allMemberId }"
                :data-user-id="userInfo.userId"
                :data-user-name="userInfo.userName"
                :data-company-id="userInfo.companyId"
                :data-user-ingroup="'1'"
                @mouseup="CANCEL_EVENT({event: $event})"
                @click="CANCELEVENT({event: $event})"
                @mousedown="memberClicked($event)"
                @keydown="selectorKeyDown(e)"
                >
                <div class="img user-photo">
                  <img v-if="userInfo.userId === allMemberId" src="@/assets/img/dummy/no-avatars.png" :data-user-id="userInfo.userId" alt="">
                  <img v-else src="@/assets/img/no-avatar.png" :data-user-id="userInfo.userId" alt="">
                </div>
                <b class="name ell-singleline" v-if="userInfo.userId !== allMemberId">
                  {{ reduceLen(userInfo.userName, 7) }}
                  <span v-if="userInfo.jobPositionName">{{userInfo.jobPositionName}}</span>
                </b>
                <span :class="userInfo.userId === allMemberId ? 'member-all_txt' : 'team'" class="ell-singleline">
                  <span v-if="userInfo.userId === allMemberId">{{ userInfo.userName }}</span>
                  <span v-if="userInfo.companyName">{{userInfo.companyName}}</span>
                  <span v-if="userInfo.deptName">/ {{userInfo.deptName}}</span>
                </span>
              </li>
              </template>
            </ul>
          </dd>
          <dd v-else>
            <div class="message" v-html="$i18nUtil.trans('search.012.001','해당 검색어와 일치하는 사용자가 없습니다.')">
            </div>
          </dd>
        </dl>
        <dl v-if="memberOnly">
          <dt>
            {{ $i18nUtil.trans("message.MemberListSelectorNew.003","찾으시는 멤버가 없으면, 멤버로 추가해 주세요.") }}
          </dt>
        </dl>
        <dl v-else>
          <dt>
            {{$i18nUtil.trans('message.MemberListSelectorNew.001','멤버 외 검색 결과')}}
            <span v-if="codeAutoInvite && state.autoInvite">
              {{$i18nUtil.trans('message.MemberListSelectorNew.004','(선택 시 멤버로 자동 추가됩니다.)')}}
            </span>
            <!-- 멤버 외 검색 결과 
            <span v-if="state.autoInvite">
            (선택 시 멤버로 자동 추가됩니다.)
            </span> -->
          </dt>
          <dd v-if="state.searchedUserList.length > 0">
            <ul class="member-list">
              <li
                v-for="(userInfo, inx) in state.searchedUserList"
                :key="inx + state.localUserList.length"
                class="memberlist-item"
                :class="(inx + state.localUserList.length == state.selected ||
                  (state.localUserList.length + state.searchedUserList.length) == 1) ?
                  'memberlist-selected' : ''"
                :data-user-id="userInfo.userId"
                :data-user-name="userInfo.userName"
                :data-company-id="userInfo.companyId"
                :data-user-ingroup="''"
                @mouseup="CANCEL_EVENT({event: $event})"
                @click="CANCEL_EVENT({event: $event})"
                @mousedown="memberClicked($event)"
                @keydown="selectorKeyDown(e)"
                >
                <div class="img user-photo">
                  <img src="@/assets/img/no-avatar.png" :data-user-id="userInfo.userId" alt="">
                </div>
                <b class="name ell-singleline">
                  {{ reduceLen(userInfo.userName, 6) }}
                  <span v-if="userInfo.jobPositionName">{{userInfo.jobPositionName}}</span>
                </b>
                <span class="team ell-singleline">
                  <span v-if="userInfo.companyName">{{userInfo.companyName}}</span>
                  <span v-if="userInfo.deptName">/ {{userInfo.deptName}}</span>
                </span>
              </li>
            </ul>
          </dd>
          <dd v-else-if="state.searchStr.length >= 2 && state.isSearching">
            <div class="loading-box">
              <div class="loader_wrap">
                <div class="loader">
                  Loading...
                </div>
              </div>
              <div class="txt">
                {{ $i18nUtil.trans("message.MemberListSelectorNew.002","요청하신 검색결과를 불러오고 있습니다.") }}
              </div>
            </div>
          </dd>
          <dd v-else>
            <div class="message" v-html="$i18nUtil.trans('search.012.001','해당 검색어와 일치하는 사용자가 없습니다.')">
            </div>
          </dd>
        </dl>
      </div>
      <div v-else class="scroll">
        <dl>
          <dd>
            <div class="message nodata" v-html="$i18nUtil.trans('search.012','해당 검색어와 일치하는 사용자가 없습니다.')">
            </div>
          </dd>
        </dl>
        <dl v-if="memberOnly">
          <dt>
            {{ $i18nUtil.trans("message.MemberListSelectorNew.003","찾으시는 멤버가 없으면, 멤버로 추가해 주세요.") }}
          </dt>
        </dl>
      </div>
    </div>
  </div>
</template>
<script>

import { mapState, mapActions, mapMutations } from "vuex";
import lodash from "lodash";

export default {
  props: {
    localUserList: {
      type: Array,
      required: true,
    },
    selected: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 0,
    },
    groupId: String,
    projectId: String,
    paperId: String,
    memberOnly: {
      type: Boolean,
      default: false
    },
    callLocation: String,
    allMemberId: String,
    section:String,
    pDocGrade:String,
    cDocGrade:String,
  },
  data() {
    return {
      state: {
        localUserList: [ ],
        searchedUserList: [ ],
        selected: 0,
        eventTrigger: false,
        searchStr: "",
        isSearching: false,
        currentEventId: false,
        autoInvite: false, // 1: 보드, 2: 과제
      },
      context: { },
      /* TB_CODE. 멤버 자동 추가 사용 여부 */
      codeAutoInvite: localStorage.getItem('autoInvite') === 'true' ? true : false,
    };
  },
  mounted() {
    this.reloadLocalUsers();
  },
  computed: {
    ...mapState("evdControl", ["KEYCODES", "EVENT_TYPES"]),
  },
  watch: {
    localUserList() {
      this.reloadLocalUsers();
    },
    selected() {
      this.state.selected = this.selected;
    },
    "state.searchStr"() {
      let self = this;
      let str = this.state.searchStr;
      let userList = this.state.searchedUserList;
      if (this.memberOnly) {
        /* 보드에 속한 멤버만 조회할 경우 사진만 읽어오고 종료 */
        this.loadUserPhoto();
        return;
      }
      this.state.isSearching = true;
      if (str && str.length >= 2) {
        let request = {
          req: { 
            searchKeyword: str,
            searchCondition: "USER",
          },
          url: "/api/auth/org/searchByUserName",
          method: "post",
        };
        lodash.debounce(() => {
          self
            .COWORK_REST_ACTION(request)
            .then((res) => {
              if (res.errorCode != null) {
              } else if (res.result) {
                userList.splice(0, userList.length);
                res.result.forEach(item => {
                  let found = false;
                  for (let inx in self.state.localUserList) {
                    if (self.state.localUserList[inx].userId === item.userId) {
                      found = true;
                      break;
                    }
                  }
                  if (!found) {
                    // console.log("USER:", item);
                    if (item.userId && item.userName) {
                      userList.push(item);
                    }
                  }
                });;
              }
              this.loadUserPhoto();
              self.state.isSearching = false;
                let context = self.context[self.state.currentEventId];
                if (context && context.config && context.config.searchCallback) {
                  context.config.searchCallback(
                    self.state.localUserList,
                    self.state.searchedUserList,
                  );
                }
            })
            .catch(function (err) {
              console.log(err);
            });
        }, 100)();
      }
      else {
        userList.splice(0, userList.length);
      }
    }
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),
    ...mapActions("coworkUtils", ["HW_GET_USER_PHOTO", "HW_KEYGEN", "CHECK_AND_LAUNCH"]),
    ...mapActions("evdControl", ["CREATE_EVENT", "TRIGGER_EVENT", "CANCEL_EVENT"]),
    ...mapActions("modals", ["showModal"]),

    memberClicked(e) {
      this.CANCEL_EVENT({event: e});
      let target = e.target;
      for (let inx = 0; target && inx < 4; inx++) {
        if (target.nodeName == "LI" && 
          target.getAttribute("class").split(/[ ]+/).indexOf("memberlist-item") != -1) {
            // console.log("TARGET:", target, this.$el.onSelected);
            let context = this.context[this.state.currentEventId];
            if (context && context.config.onSelected) {   
              let inGroup = target.getAttribute("data-user-ingroup");
              if(this.section == "SHAR" && this.cDocGrade == "NORMAL" && this.pDocGrade == "SECRET"){
                // 정보공유 보드일경우 호출발송.
                context.config.onSelected(target); 
              } else{
                if (this.codeAutoInvite || inGroup === '1') {
                  // CASE 1. 선택된 사용자 자동 추가 O
                  // CASE 2. 현재 멤버
                  context.config.onSelected(target); 
                }
                else {
                  // CASE 3. 멤버 아닌 사용자 자동 추가 X -> 멘션 태그 삭제 O
                  context.config.onSelected(null);
                  this.alertAutoInviteIsFalse();
                }
              }
            }
            break;
        }
        target = target.parentNode;
      }
    },
    selectorKeyDown(e) {

    },
    copyKbdAttr(e, state) {
      state.keyCode = e.keyCode;
      state.ctrlKey = e.ctrlKey;
      state.altKey = e.altKey;
      state.shiftKey = e.shiftKey;
      state.target = e.target;
    },
    editorKeyInput(e) {
      this.copyKbdAttr(e, this.state);
      if (!this.keyboardInterrupt(e, this.EVENT_TYPES.KEYINPUT)) { return false; }
      return true;
    },
    editorKeyUp(e) {
      this.copyKbdAttr(e, this.state);
      if (!this.keyboardInterrupt(e, this.EVENT_TYPES.KEYUP)) { return false; }
      return true;
    },
    editorKeyDown(e, config) {
      this.copyKbdAttr(e, this.state);
      if (!this.keyboardInterrupt(e, this.EVENT_TYPES.KEYDOWN)) {
        this.CANCEL_EVENT({event: e});
        return false;
      }
      if (!config) { config = { }; }
      config.input = e.target;
      if (!this.processKeyDown(e, this.state, config)) {
        this.CANCEL_EVENT({event: e});
        return false;
      }
      return true;
    },
    keyboardInterrupt(e, etype) {
      let ret = true;
      if (this.context) {
        for (let key in this.context) {
          let proc = this.context[key];
          // console.log("KEY:", key, proc);
          if (proc) {
            if (ret && etype == this.EVENT_TYPES.KEYINPUT && proc.keyinput) {
              ret = proc.keyinput(e);
            }
            else if (ret && etype == this.EVENT_TYPES.KEYDOWN && proc.keydown) {
              ret = proc.keydown(e);
            }
            else if (ret && etype == this.EVENT_TYPES.KEYUP && proc.keyup) {
              ret = proc.keyup(e)
            }
            if (!ret) {
              break;
            }
          }
        }
      }
      if (!ret) {
        this.CANCEL_EVENT({event: e});
      }
      return ret;
    },
    memberViewHide(cancel, item, uid, caret, config) {
      this.$el.classList.add("hidden");
      this.$el.style.top = "0";
      this.$el.style.left = "0";

      delete this.context[uid];
      if (caret && caret.tag) {
        let tag = caret.tag;
        let nextNode = tag.nextSibling;
        let parentNode = tag.parentNode;
        if (nextNode) {
          document.getSelection().collapse(nextNode, 1);
        }
        else {
          if (parentNode && parentNode.nodeValue) {
            document.getSelection().collapse(parentNode, parentNode.nodeValue.length);
          }
        }
        if (cancel && tag.parentNode) {
          parentNode.removeChild(tag);
        }
        else {
          /* TODO 완료되었으므로 다음위치에 커서 이동 */
        }
        if (this.state.target) {
          this.state.target.removeAttribute("data-uid-memberlist-selector");
          delete this.state.target;
        }
      }

      this.state.searchStr = "";
      this.state.isSearching = false;
      this.state.localUserList.splice(0, this.state.localUserList.length);
      this.state.searchedUserList.splice(0, this.state.searchedUserList.length);
      if (config && config.closeCallback) {
        setTimeout(() => { config.closeCallback(cancel, item, caret); }, 1);
      }
    },
    memberViewScroll() {
      let view = this.$refs.selectorView.querySelector("div.scroll");
      let item = this.$el.querySelector("ul li.memberlist-selected");
      if (item) {
        let box = item.parentNode;
        let top = item.offsetTop + box.offsetTop - 50;
        // console.log("ITEM:", top, view.scrollTop);
        if ((top - view.scrollTop) < 0) {
          view.scrollTop = top - 10;
          if (view.scrollTop < 0) { view.scrollTop = 0; }
        }
        else if ((top + item.offsetHeight - view.scrollTop) > view.offsetHeight) {
          view.scrollTop = top + item.offsetHeight - view.offsetHeight + 20;
        }
      }
    },
    memberSelected(item, uid, caret, config) {
      // console.log("ITEM:", item, caret);
      if (item) {
        let userId = item.getAttribute("data-user-id");
        let userName = (userId === this.allMemberId) ? this.$i18nUtil.trans("message.MemberListSelector.000", "전체멤버") 
                                                : item.getAttribute("data-user-name");
        let companyId = item.getAttribute("data-company-id");
        let userInGroup = item.getAttribute("data-user-ingroup");
        let element = null;

        if (userId) {
          if (caret.element) {
            element = caret.element;
            let parent = element.parentNode;
            let newTag = document.createElement("span");
            let nextTag = element.nextSibling;
            
            newTag.innerHTML = "@" + userName;
            newTag.classList.add("mention");
            element.classList.add("hidden");

            newTag.setAttribute("data-user-id", userId);
            newTag.setAttribute("data-user-name", userName);
            newTag.setAttribute("data-company-id", companyId);
            
            // data-callEx-id : 호출 메일 발송시 해당 멘션이 살아있는지 확인하기위한 용도.  CALL MAILL EXIST
            let res = [];
            this.HW_KEYGEN({head: "CMEX", res});
            let callFindKey = res[0];
            newTag.setAttribute("data-callEx-id", callFindKey);
            item.setAttribute("data-callEx-id", callFindKey);

           
            parent.insertBefore(newTag, element);
            parent.insertBefore(document.createTextNode(" "), element);
            if (!nextTag) {
              nextTag = document.createTextNode(" ");
              parent.appendChild(nextTag);
            }
            caret.element = newTag;
            element.innerHTML = "";
            setTimeout(() => {
              if (parent.contains(element)) {
                parent.removeChild(element);
              }
              let range = document.getSelection().getRangeAt(0);
              element = range.startContainer;
              if (element.nodeValue) {
                element.nodeValue = element.nodeValue.substring(1);
                if (config.input.classList.contains("ProseMirror")) {
                  document.getSelection().collapse(element, 1);
                }
                else {
                  document.getSelection().collapse(element, 0);
                }
              }
              if (config.input.classList.contains("ProseMirror")) {
                /* 2021-09-14 멤버 선택 후, 하단 텍스트 블럭 따라 올라가 멘션 블락과 합쳐지는 현상 조치 */
                // caret.element = element.previousSibling;
                caret.element = element.previousSibling == null ? element : element.previousSibling;
              }
            }, 1);
          }
          this.memberViewHide(false, item, uid, caret, config);
          if (!userInGroup && config.autoInvite && this.codeAutoInvite) {
            this.inviteMember(userId, companyId, config);
          }
        }
        else {
          this.memberViewHide(true, item, uid, caret, config);
        }
      }
      else {
        this.memberViewHide(true, null, uid, caret, config);
      }
    },
    calcPosition(caretElement, config) {
      let self = this;
      self.state.autoInvite = config.autoInvite;
      let memberListElement = self.$el;
      memberListElement.classList.add("hidden");
      memberListElement.style.top = "0";
      memberListElement.style.left = "0";
      setTimeout(() => {
        let pos = {
          top: 0,
          left: 0,
          reverse: false,
        };
        if (config.positionAdjust) {
          config.positionAdjust(pos, caretElement);
        }
        if (config.contentEditable) {
          if (caretElement && caretElement.innerHTML.length > 0) {
            // console.log("POS:", 
            //   pos.top, pos.left, 
            //   memberListElement.offsetTop, memberListElement.offsetLeft, 
            //   caretElement.offsetTop, caretElement.offsetLeft);
            pos.top += (memberListElement.offsetTop + caretElement.offsetTop);
            pos.left += (memberListElement.offsetLeft + caretElement.offsetLeft);
            setTimeout(() => { memberListElement.classList.remove("hidden"); }, 10);
            memberListElement.style.top = pos.top + "px";
            memberListElement.style.left = pos.left + "px";
            self.reversePosition(pos.reverse);
            self.$refs.selectorView.scrollTop = 0;
          }
        }
        else {
            // console.log("POS:", 
            //   pos.top, pos.left, 
            //   memberListElement.offsetTop, memberListElement.offsetLeft, 
            //   caretElement.offsetTop, caretElement.offsetLeft);
            pos.top += (memberListElement.offsetTop + caretElement.offsetTop);
            pos.left += (memberListElement.offsetLeft + caretElement.offsetLeft);
            memberListElement.classList.remove("hidden");
            memberListElement.style.top = pos.top + "px";
            memberListElement.style.left = pos.left + "px";
            self.reversePosition(pos.reverse);
            self.$refs.selectorView.scrollTop = 0;
        }
      }, 100);
    },
    processKeyDown(e, kbdInfo, config) {
      let self = this;
      let keyCode = kbdInfo.keyCode;
      let memberListElement = self.$el;
      let res = [];
      let KEYCODES = self.KEYCODES;

      if (e.openMemberList || (keyCode == KEYCODES.KP2 && kbdInfo.shiftKey)) {
        // console.log("@");
        let input = e.target;
        let tag = document.createElement("span");
        self.HW_KEYGEN({head: "SPAN", res});
        let idStr = res[0];
        let caret = {
          element: tag,
          tag: tag,
          text () { return caret.element.innerText; },
          parent () { return caret.element.parentNode; },
        };

        let kbdProc = function(e, etype, level) {
          let ret = true;
          let keyCode = e.keyCode;
          // console.log("KEY-CODE:", etype, keyCode, level, e.shiftKey, e.ctrlKey);

          if (keyCode == KEYCODES.ESC && self.isIn(1, level)) {
            config.onHidden(true);
            ret = false;
          }
          else if (keyCode == KEYCODES.UP && self.isIn(1, level)) {
            /* 멤버선택창 커서 위로 */
            if (self.state.selected > 0) {
              self.state.selected --;
              setTimeout(self.memberViewScroll, 20);
            }
            ret = false;
          }
          else if (keyCode == KEYCODES.DOWN && self.isIn(1, level)) {
            /* 멤버선택창 커서 아래로 */
            if (self.state.selected < 
              (self.state.localUserList.length + self.state.searchedUserList.length - 1)) {
              self.state.selected ++;
              setTimeout(self.memberViewScroll, 20);
            }
            ret = false;
          }
          else if (keyCode == KEYCODES.LEFT && self.isIn(1, level)) { ret = false; }
          else if (keyCode == KEYCODES.RIGHT && self.isIn(1, level)) { ret = false; }
          else if (keyCode == KEYCODES.PGUP && self.isIn(1, level)) {
            /* 멤버선택창 커서 페이지업 */
            if (self.state.selected - 5 > 0) {
              self.state.selected -= 5;
              setTimeout(self.memberViewScroll, 20);
            }
            else {
              self.state.selected = 0;
              setTimeout(self.memberViewScroll, 20);
            }
            ret = false;
          }
          else if (keyCode == KEYCODES.PGDN && self.isIn(1, level)) {
            /* 멤버선택창 커서 페이지다운 */
            if (self.state.selected + 5 < 
              (self.state.localUserList.length + self.state.searchedUserList.length - 1)) {
              self.state.selected += 5;
              setTimeout(self.memberViewScroll, 20);
            }
            else {
              self.state.selected = (self.state.localUserList.length + self.state.searchedUserList.length - 1);
              setTimeout(self.memberViewScroll, 20);
            }
            ret = false;
          }
          else if (keyCode == KEYCODES.HOME && self.isIn(1, level)) {
            /* 멤버선택창 커서 맨처음 */
            self.state.selected = 0;
            setTimeout(self.memberViewScroll, 20);
            ret = false;
          }
          else if (keyCode == KEYCODES.END && self.isIn(1, level)) {
            /* 멤버선택창 커서 맨아래 */
            self.state.selected = (self.state.localUserList.length + self.state.searchedUserList.length - 1);
            setTimeout(self.memberViewScroll, 20);
            ret = false;
          }
          else if ((keyCode == KEYCODES.BS || keyCode == KEYCODES.DEL) && !self.state.eventTrigger
            && caret.text().replace(/[ ]*/gi, "") === "@" && self.isIn(1, level)) {
            /* "@" 만 남은 상황에서 Backspace || Delete */
            config.onHidden (true);
            ret = false;
          }
          else if ((keyCode == KEYCODES.ENTER || keyCode == KEYCODES.SPACE) && self.isIn(1, level)) {
            /* 멤버선택확정 */
            if (config.input && config.input.classList.contains("ProseMirror")) {
              self.TRIGGER_EVENT({element: input, type: self.EVENT_TYPES.KEYDOWN, attr: { keyCode: KEYCODES.BS }});
            }
            let item = memberListElement.querySelector("ul li.memberlist-selected");
            if (item !== null) {
              let inGroup = item.getAttribute("data-user-ingroup");
              if(self.section == "SHAR" && self.cDocGrade == "NORMAL" && self.pDocGrade == "SECRET"){
                // 정보공유 보드일경우 호출발송.
                config.onSelected(item);
                ret = false;
              }else{
                if (self.codeAutoInvite || inGroup === '1') {
                  // CASE 1. 선택된 사용자 자동 추가 O
                  // CASE 2. 현재 멤버
                  config.onSelected(item);
                  ret = false;
                }else {
                  // CASE 3. 멤버가 아닌 사용자 자동 추가 X (멘션 태그 삭제 O)
                  config.onSelected(null);
                  ret = false;
                  self.alertAutoInviteIsFalse();
                }
              }
            }
            else if (item === null) {
              // CASE 4. 선택된 멤버/사용자 X
              let element = caret.element;
              let parent = element.parentNode;
              let newElement = document.createTextNode(caret.text());
              element.classList.add("hidden");
              parent.insertBefore(newElement, element);
              element.innerHTML = "";
              setTimeout(() => {
                if (parent.contains(element)) {
                  parent.removeChild(element);
                }
                document.getSelection().collapse(newElement, newElement.length); // 커서 위치 조작
              }, 1);
              config.onHidden(false); // 멘션 태그 삭제 X
              ret = false;
            }
          }
          else if (keyCode == KEYCODES.KP2 && kbdInfo.shiftKey && self.isIn(3, level)) {
            if (etype == self.EVENT_TYPES.KEYDOWN && caret.parent()) {
              let newNode = document.createTextNode("@");
              caret.parent().insertBefore(newNode, caret.element);
              self.calcPosition(caret.tag, config);
            }
            self.CANCEL_EVENT({event: e});
            ret = false;
          }
          else if (self.isIn(3, level)) {
            /* 일반키보드 입력 이벤트, 멤버 검색을 위해 사용 */
            if (config.contentEditable) {
              let ptnAt = /^[@]([^ ^ ^@^\t^\0]*)$/;
              let text = caret.text();
              let match = ptnAt.exec(text);
              if (caret.parent() == null || !match) {
                config.onHidden(true);
                ret = false;
              }
              else {
                setTimeout(() => {
                  let str = ptnAt.exec(text)[1];
                  self.state.searchStr = str;
                  self.searchLocalUsers(str);
                }, 10)
                // console.log(str);
              }
            }
            else {
              let str = caret.text();
              if (str) {
                self.state.searchStr = str;
                self.searchLocalUsers(str);
              }
            }
          }
          // console.log("RET:", ret);
          return ret;
        };

        /* 입력객체가 div[contentEditable] 인지 input 인지 구별하여 수행 */
        if (config.contentEditable) {
          let range = document.getSelection().getRangeAt(0);
          tag.innerHTML = "@";
          tag.classList.add("mention");
          tag.setAttribute("id", idStr);
          self.insertAtCaret(range, tag, input, true);

          self.CHECK_AND_LAUNCH({
            check: (ctx) => {
              return (ctx.elem = input.querySelector("span#" + idStr));
            },
            launch: (ctx) => {
              tag = ctx.elem;
              tag.removeAttribute("id");
              caret.element = tag;
              caret.tag = tag;

              if (tag && tag.innerHTML.length > 0) {
                self.calcPosition(tag, config);
                self.reloadLocalUsers();

                self.HW_KEYGEN({head: "EVNT", res});
                let uid = res[0];
                input.setAttribute("data-uid-memberlist-selector", uid);
                self.state.currentEventId = uid;
                self.state.target = input;
                config.eventId = uid;

                config.onHidden = function(cancel) {
                  self.memberViewHide(cancel, null, uid, caret, config);
                };
                config.onSelected = function(item) {
                  if (item !== null) {
                    /* START 2021-09-14 멤버 선택 후, 하단 텍스트 블럭 따라 올라가 멘션 블락과 합쳐지는 현상 조치 */
                    if (config.input && config.input.classList.contains("ProseMirror")) {
                      self.TRIGGER_EVENT({element: input, type: self.EVENT_TYPES.KEYDOWN, attr: { keyCode: KEYCODES.ENTER }});
                    }
                    /* END 2021-09-14 멤버 선택 후, 하단 텍스트 블럭 따라 올라가 멘션 블락과 합쳐지는 현상 조치 */
                  }
                  self.memberSelected(item, uid, caret, config);
                };
                config.onKeyboard = function(e) { return kbdProc(e, self.EVENT_TYPES.KEYDOWN, [1, 2]); };
                self.context[uid] = {
                  keyup: function(e) { return kbdProc(e, self.EVENT_TYPES.KEYUP, [2]); },
                  keydown: function(e) { return kbdProc(e, self.EVENT_TYPES.KEYDOWN, [1, 3]); },
                  keyinput: function(e) { return kbdProc(e, self.EVENT_TYPES.KEYINPUT, [3]); },
                  config: config,
                  caret: caret,
                };
              }

              /* IE fix */
              tag.focus();
              document.getSelection().collapse(tag, 1);
              return;
            }
          });
        }
        else {
          tag = e.target;
          caret.element = tag;
          caret.tag = null;
          caret.text = function() { return tag.value; };
          caret.parent = function() { return tag.parentNode; };

          self.calcPosition(tag, config);
          self.reloadLocalUsers();

          self.HW_KEYGEN({head: "EVNT", res});
          let uid = res[0];
          input.setAttribute("data-uid-memberlist-selector", uid);
          self.state.currentEventId = uid;
          self.state.target = input;
          config.eventId = uid;

          config.onHidden = function(cancel) {
            self.memberViewHide(cancel, null, uid, caret, config);
          };
          config.onSelected = function(item) {
            self.memberSelected(item, uid, caret, config);
          };
          config.onKeyboard = function(e) { return kbdProc(e, self.EVENT_TYPES.KEYDOWN, [1, 2]); };
          self.context[uid] = {
            keyup: function(e) { return kbdProc(e, self.EVENT_TYPES.KEYUP, [2]); },
            keydown: function(e) { return kbdProc(e, self.EVENT_TYPES.KEYDOWN, [1, 3]); },
            keyinput: function(e) { return kbdProc(e, self.EVENT_TYPES.KEYINPUT, [3]); },
            config: config,
            caret: caret,
          };
        }
        return false;
      }
      return true;
    },
    insertAtCaret(range, newNode, root, focus) {
      let currentNode = range.endContainer;
      let parentNode = currentNode.parentNode;
      let nextNode = currentNode.nextSibling;
      let offset = range.endOffset;
      let isIE = this.isIE();
      // console.log("NODE:", currentNode, parentNode, offset);
      if (currentNode.nodeName === "#text") {
        let prevText = currentNode.nodeValue.substring(0, offset);
        let nextText = currentNode.nodeValue.substring(offset);
        let textNode = document.createTextNode((isIE ? " " : "\0") + nextText);
        currentNode.nodeValue = prevText + (isIE ? " " : "\0");
        if (nextNode) {
          parentNode.insertBefore(newNode, nextNode);
          parentNode.insertBefore(textNode, nextNode);
        } else
        {
          parentNode.appendChild(newNode);
          parentNode.appendChild(textNode);
        }
        if (focus) { newNode.focus(); }
        document.getSelection().collapse(newNode, 1);
      }
      else {
        if (parentNode != root) {
          if (currentNode.nodeValue) {
            /* TIPTAP 에디터에서 중간삽입 */
            let prevText = currentNode.nodeValue.substring(0, offset);
            let nextText = currentNode.nodeValue.substring(offset);
            let textNode = document.createTextNode((isIE ? " " : "\0") + nextText);
            // console.log("PT:" + prevText + " / NT:" + nextText);
            currentNode.nodeValue = prevText;
            if (nextNode) {
              parentNode.insertBefore(newNode, nextNode);
              parentNode.insertBefore(textNode, nextNode);
            }
            else {
              parentNode.appendChild(newNode);
              parentNode.appendChild(textNode);
            }
          }
          else {
            /* div(일반) 에디터에서 중간삽입 */
            currentNode.appendChild(document.createTextNode(isIE ? " " : "\0"));
            currentNode.appendChild(newNode);
            currentNode.appendChild(document.createTextNode(isIE ? " " : "\0"));
          }
          if (focus) { newNode.focus(); }
          document.getSelection().collapse(newNode, 1);
        }
        else {
          /* 에디터 최초입력 */
          let textNode = document.createTextNode(" ");
          if (!currentNode.innerHTML.replace(/[ \t\r\n]+/g, "")) {
            currentNode.innerHTML = "<span></span>";
          }
          currentNode.appendChild(newNode);
          currentNode.appendChild(textNode);
          if (focus) { newNode.focus(); }
          document.getSelection().collapse(newNode, 1);
        }
      }
      return newNode;
    },
    cancelMemberSelect(el) {
      if (el) {
        let uid = el.getAttribute("data-uid-memberlist-selector");
        if (uid && this.context[uid]) {
          let context = this.context[uid];
          this.memberViewHide(true, null, uid, context.caret, context.config);
        }
      }
    },
    isIn(value, list) {
      let ret = false;
      if (!list || !(list instanceof Array) || list.length == 0) { return ret; }
      if (value instanceof Array) {
        for (let inx = 0; inx < value.length; inx++) {
          if (list.indexOf(value[inx]) != -1) {
            ret = true;
            break;
          }
        }
      }
      else {
        if (list.indexOf(value) != -1) {
          ret = true;
        }
      }
      return ret;
    },
    reloadLocalUsers() {
      this.state.localUserList.splice(0, this.state.localUserList.length);
      /* 보드멤버 전체 호출 추가 */
      if (this.callLocation === 'board') { this.addAllMemerCall(); }
      for (let inx = 0; inx < this.localUserList.length; inx++) {
        let info = this.localUserList[inx];
        if (info.userId && info.userName) {
          this.state.localUserList.push(info);
        }
      }
      this.loadUserPhoto();
      // this.state.selected = 0;

      // 보드에서 호출 시, 멤버 목록 init 포커싱 [보드멤버 전체] > [멤버]로 변경
      this.state.selected = (this.callLocation === 'board') ? 1 : 0;
    },
    loadUserPhoto: lodash.debounce(function() {
      let list = this.$el.querySelectorAll(".img.user-photo > img[data-user-id]");
      for (let inx in list) {
        let img = list[inx];
        if (img && img.getAttribute) {
          let userIdData = img.getAttribute("data-user-id");
          if (userIdData !== this.allMemberId)
            this.HW_GET_USER_PHOTO({img, userId: userIdData})
        }
      }
    }, 500), 
    searchLocalUsers(str) {
      this.state.localUserList.splice(0, this.state.localUserList.length);
      /* 보드멤버 전체 호출 추가 */
      if (this.callLocation === 'board') {
        let keyword;
        let search = ["all", "전체멤버"];
        search.filter(match => { if (str.toLowerCase() === match.slice(0, str.length)) keyword = match; })
        if (str.length < 1 || (keyword !== undefined && str.toLowerCase() === keyword.slice(0, str.length))){
          this.addAllMemerCall();
        }
      }
      for (let inx = 0; inx < this.localUserList.length; inx++) {
        let info = this.localUserList[inx];
        if (info.userId && info.userName && info.userName.substring(0, str.length) == str) {
            this.state.localUserList.push(info);
        }
      }
      this.state.selected = 0;
    },
    reversePosition(reverse) {
      /* 커서를 중심으로 멤버선택창을 상단 / 하단에 위치하기 */
      let view = this.$refs.selectorView;
      if (reverse) {
        view.style.bottom = "auto";
        view.style.top = "1.5em";
      }
      else {
        view.style.bottom = "0";
        view.style.top = "auto";
      }
    },
    reduceLen(str, len) {
      let ret = str;
      if (ret && ret.length > len) {
        ret = ret.substring(0, len);
        ret += "..";
      }
      return ret;
    },
    isIE() {
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf("MSIE ");
      const trident = ua.indexOf("Trident/");
      return (msie > 0 || trident > 0);
    },
    inviteMember(userId, companyId, config, callFindKey) {
      let self = this;
      let request = {};
      if (config.autoInvite === 1) {
        let userList = [{
          paperUserId: userId,
          companyId: companyId,
          userGrade: "MEMBER",
          userKbn: "01",
          callFindKey: callFindKey
        }];
        request = {
          url: "/api/copaper/paperuser/registPaperUser",
          method: "post",
          req: {
            paperId: self.paperId,
            addPaperUserList: userList,
          },
        };
      }
      else if (config.autoInvite === 2) {
        let userList = [{
          groupId: self.groupId, 
          userId: userId,
          userGrade: "MEMBER",
          userKbn: "01",
          callFindKey: callFindKey
        }];
        request = {
          url: "/api/cogroup/cogroupUser/registCogroupUser",
          method: "post",
          req: {
            groupId: self.groupId,
            addCogroupUserList: userList,
          },
        };
      }

      self
        .COWORK_REST_ACTION(request)
        .then((res) => {
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            let blockedList = [];
            if (res.result) {
              if (config.autoInvite === 1) {
                blockedList = res.result.policyBlockUserList;
              } else if (config.autoInvite === 2) {
                blockedList = res.result.blockUser;
              }
              if (blockedList) {
                console.log("[사용자 차단]", blockedList);
              }
              if (res.result.data) {
                console.log("[멤버추가 성공]", userId);
                /* 멤버 업데이트 수행 */
                self.localUserList.splice(0, self.localUserList.length);
                res.result.data.forEach(item => {
                  if (item.userId && item.userName) {
                    self.localUserList.push(item);
                  }
                });
              }
            }
            if (config && config.inviteCallback) {
              config.inviteCallback(true, userId, companyId, self.localUserList, blockedList);
            }
          }
        })
        .catch((err) => {
          if (config && config.inviteCallback) {
            config.inviteCallback(false, userId, companyId, self.localUserList, blockedList);
          }
          console.log(err);
          console.log("[멤버추가 오류]");
          // alert("[멤버추가 오류]");
        });
    },
    /* 멤버 호출 레이어: 보드멤버 전체 항목 추가 */
    addAllMemerCall() {
      let callAllMember = {
        userId: this.allMemberId,
        userName: this.$i18nUtil.trans("message.MemberListSelector.000", "전체멤버"),
      }
      this.state.localUserList.splice(0, 0, callAllMember);
    },
    /* 멤버 외 사용자 자동 추가 X: 알림 */
    alertAutoInviteIsFalse() {
      let self = this;
      setTimeout(() => {
        self.showAlertDialog(self.$i18nUtil.trans("message.MemberListSelector.001", "해당 사용자는 멤버가 아닙니다.\n멤버 추가 후 다시 수행해 주십시오."))
      }, 100)
    }
  },
}
</script>
<style scoped>
.member-call-box > .scroll > dl {
  padding-left: 0;
}

.member-call-box > .scroll dd > .member-list > li {
  padding-left: 35px;
  padding-right: 5px;
}
.member-call-box > .scroll dd > .member-list > li .img {
  left: 8px;
}

.memberselector-view {
  left: -10px;
  bottom: 0; 
  box-sizing: border-box; 
  position: absolute; 
  display: block
}
.memberlist-selected {
  background: #eaecf0;
}

.member-call-box {
  left: -10px;
  bottom: 0; 
  box-sizing: border-box; 
  position: absolute; 
  display: block
}
.member-call-box > .scroll dd > .member-list > li.member-all > .member-all_txt {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/cowork/general/board/extensions/MemberListSelector.vue